import { useEffect, useState } from "react";

export const useMediaQuery = (query: string) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = useState<boolean>(mediaMatch.matches);

    useEffect(() => {
        const handler = (event: MediaQueryListEvent) => setMatches(event.matches);
        mediaMatch.addEventListener("change", handler);

        return () => mediaMatch.removeEventListener("change", handler);
    });

    return matches;
};
